module.exports = __webpack_public_path__ + "img/hotel3_4.5202f89f.png";